module.exports = __webpack_public_path__ + "static/img/5.487f750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/5.png
// module id = RXXY
// module chunks = 0